import React from "react";
const H1Icon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16px",
    height: "11px",
    viewBox: "0 0 18 13",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { id: "📟--Specs-for-devs", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "g",
    {
      id: "Mobile-headings",
      transform: "translate(-165.000000, -687.000000)",
      fill: "#000000",
      fillRule: "nonzero"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M167.535659,699.5 L167.535659,694.026 L173.060659,694.026 L173.060659,699.5 L175.185659,699.5 L175.185659,687.362 L173.060659,687.362 L173.060659,692.19 L167.535659,692.19 L167.535659,687.362 L165.410659,687.362 L165.410659,699.5 L167.535659,699.5 Z M182.393659,699.5 L182.393659,687.6 L180.812659,687.6 C180.744659,687.962667 180.600159,688.268667 180.379159,688.518 C180.158159,688.767333 179.891826,688.971333 179.580159,689.13 C179.268493,689.288667 178.919993,689.402 178.534659,689.47 C178.149326,689.538 177.752659,689.572 177.344659,689.572 L177.344659,689.572 L177.344659,691.102 L180.268659,691.102 L180.268659,699.5 L182.393659,699.5 Z",
        id: "H1"
      }
    )
  ))
);
export {
  H1Icon
};
//# sourceMappingURL=H1Icon.js.map
